var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15.5,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1926 20.3545V19.6318C16.1926 19.1891 16.2545 18.7985 16.3782 18.46C16.5019 18.1149 16.7005 17.7894 16.9739 17.4834C17.2473 17.1709 17.6087 16.8519 18.0579 16.5264C18.4615 16.2399 18.7838 15.9827 19.0247 15.7549C19.2721 15.527 19.4511 15.3024 19.5618 15.0811C19.679 14.8532 19.7376 14.596 19.7376 14.3096C19.7376 13.8864 19.5813 13.5641 19.2688 13.3428C18.9563 13.1214 18.5201 13.0107 17.9602 13.0107C17.4003 13.0107 16.8437 13.0986 16.2903 13.2744C15.7434 13.4502 15.1868 13.6813 14.6204 13.9678L13.5559 11.8291C14.207 11.4645 14.9133 11.1715 15.6751 10.9502C16.4368 10.7223 17.2701 10.6084 18.1751 10.6084C19.5683 10.6084 20.6458 10.9437 21.4075 11.6143C22.1757 12.2783 22.5598 13.1247 22.5598 14.1533C22.5598 14.7002 22.4719 15.1755 22.2962 15.5791C22.1269 15.9762 21.8665 16.3473 21.5149 16.6924C21.1699 17.0309 20.7369 17.389 20.2161 17.7666C19.8255 18.0531 19.526 18.2939 19.3176 18.4893C19.1093 18.6846 18.9661 18.8799 18.888 19.0752C18.8163 19.264 18.7805 19.4951 18.7805 19.7686V20.3545H16.1926ZM15.8801 23.6943C15.8801 23.0824 16.0462 22.6527 16.3782 22.4053C16.7167 22.1579 17.1236 22.0342 17.5989 22.0342C18.0611 22.0342 18.4583 22.1579 18.7903 22.4053C19.1288 22.6527 19.2981 23.0824 19.2981 23.6943C19.2981 24.2803 19.1288 24.7035 18.7903 24.9639C18.4583 25.2243 18.0611 25.3545 17.5989 25.3545C17.1236 25.3545 16.7167 25.2243 16.3782 24.9639C16.0462 24.7035 15.8801 24.2803 15.8801 23.6943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint-icon.15c3fc5cf84b33a7ffe9213543ee2b22.svg";
export { ForwardRef as ReactComponent };